import api from '../clients/api';
import { notifyBugsnagNetwork } from '../utils/bugsnagClient';

const service = {
	isFakeEmail,
};

function isFakeEmail(email: string) {
	notifyBugsnagNetwork('email', 'isFakeEmail', { email });
	return api.email.isFakeEmail(email);
}

export default service;
